<template>
  <span ref="el">{{ displayValue }}</span>
</template>

<script>
export default {
  name: 'CountUp',
  props: {
    to: { type: Number, required: true },
    from: { type: Number, default: 0 },
    duration: { type: Number, default: 2 },
    separator: { type: String, default: '' },
    prefix: { type: String, default: '' },
    suffix: { type: String, default: '' },
    startWhen: { type: Boolean, default: true }
  },
  data () {
    return {
      currentValue: 0,
      isInView: false,
      hasStarted: false,
      velocity: 0,
      animationId: null
    }
  },
  computed: {
    displayValue () {
      const val = Math.round(this.currentValue)
      let formatted = val.toString()
      if (this.separator) {
        formatted = val.toLocaleString('en-US').replace(/,/g, this.separator)
      }
      return this.prefix + formatted + this.suffix
    },
    damping () {
      return 20 + 40 * (1 / this.duration)
    },
    stiffness () {
      return 100 * (1 / this.duration)
    }
  },
  watch: {
    to () {
      this.hasStarted = false
      this.currentValue = this.from
      this.startAnimation()
    },
    startWhen (val) {
      if (val && this.isInView && !this.hasStarted) {
        this.startAnimation()
      }
    }
  },
  mounted () {
    this.currentValue = this.from
    this.setupObserver()
  },
  beforeUnmount () {
    this.cleanup()
  },
  methods: {
    setupObserver () {
      if (!this.$refs.el) return
      this._observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !this.isInView) {
            this.isInView = true
            this.startAnimation()
          }
        },
        { threshold: 0 }
      )
      this._observer.observe(this.$refs.el)
    },
    startAnimation () {
      if (this.hasStarted || !this.isInView || !this.startWhen) return
      this.hasStarted = true
      this.velocity = 0
      this.animationId = requestAnimationFrame(this.springStep)
    },
    springStep () {
      const target = this.to
      const displacement = target - this.currentValue
      const springForce = displacement * this.stiffness
      const dampingForce = this.velocity * this.damping
      const acceleration = springForce - dampingForce

      this.velocity += acceleration * 0.016
      this.currentValue += this.velocity * 0.016

      if (Math.abs(displacement) > 0.5 || Math.abs(this.velocity) > 0.5) {
        this.animationId = requestAnimationFrame(this.springStep)
      } else {
        this.currentValue = target
        this.animationId = null
        this.$emit('complete')
      }
    },
    cleanup () {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId)
        this.animationId = null
      }
      if (this._observer) {
        this._observer.disconnect()
        this._observer = null
      }
    }
  }
}
</script>
